import classes from './Item.module.sass'
import trash from '../../../../../assets/images/icons/trash.svg'
import { OptionItemInterface, ValidationResultInterface } from '../../../../../common/types/interfaces'
import { SearchSelect } from '../../../../../common/components/searchSelect/SearchSelect'
import { Input } from '../../../../../common/components/input/Input'
import { IconButton } from '../../../../../common/components/iconButton/IconButton'


type Props = {
  idx: number
  item: { saleItemId?: number | string; price?: number | string }
  onRemove: (index: number) => void
  onChange: (index: number, field: string, value: string | number) => void
  onBlur: (field: string) => void
  saleItemOptions: OptionItemInterface[]
  getItemValidationResult: (
    index: number,
    field: 'saleItemId' | 'price',
  ) => ValidationResultInterface | undefined
}

export const Item = ({
  idx,
  item,
  onRemove,
  onChange,
  onBlur,
  saleItemOptions,
  getItemValidationResult,
}: Props) => {
  return (
    <div className={classes.container}>
      <div className={classes.input}>
        <SearchSelect
          onBlur={() => onBlur(`prices[${idx}].saleItemId`)}
          fieldName={`prices[${idx}].saleItemId`}
          options={saleItemOptions}
          value={item.saleItemId}
          onChangeHandler={(value: string | number | boolean) => {
            if (typeof value === 'boolean') return
            onChange(idx, 'saleItemId', value)
          }}
          type="text"
          placeholder="Товар"
          itemValidationResult={getItemValidationResult(idx, 'saleItemId')}
        />
      </div>

      <div className={classes.countInput}>
        <Input
          type={'numberText'}
          fieldName={`prices[${idx}].price`}
          value={item.price || ''}
          placeHolder="Цена"
          onChangeHandler={(value: any) => onChange(idx, 'price', value)}
          onBlur={() => onBlur(`prices[${idx}].price`)}
          itemValidationResult={getItemValidationResult(idx, 'price')}
        />
      </div>

      <div className={classes.button}>
        <IconButton display onClick={() => onRemove(idx)} icon={trash} alt="Удалить" small />
      </div>
    </div>
  )
}
